<template>
  <div class="d-flex flex-column align-center category-button" @click="(e) => $emit('click', e)">

    <!-- v-if="imageLoad"  -->
    <v-img 
      class="rounded elevation-3 category-button-image" 
      :src="type.imageUrl" 
      @error="imageLoad = false"
    />
    <!-- <v-img
      v-else
      class="rounded elevation-3 category-button-image" 
      src="@/assets/missing-service-image.png" 
    /> -->

    <div class="black--text category-button-text">{{ type.name }}</div>
  </div>
</template>

<script>
export default {
  name: 'PropertyButton',

  props: { type: Object } ,

  data: () => ({
    imageLoad: true,
  }),
}
</script>

<style scoped>
  .category-button {
    max-width: 181px;
  }
  
  .category-button-image {
    width: max-content;
    aspect-ratio: 181/102;
  }

  .category-button-text {
    max-width: 100%;
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
  }
</style>
